export class ComposicaoRacial {
    public cdcomposicaoracial: number;
    public descricao: string;
    public tipo: number;
    public ativo: number;
    public cdfazenda: number;
    public PADRAO: number;
  }
